import React  from 'react';
import "./FootNote.scss";

export function FootNote(props) {
    return (
        <a href={"#sources"} className={`footnote ${props.isBold ? "bold" : ""}`}>
            {props.content} <span style={props.style ? props.style : {}}>{props.number}</span>
        </a>
    )
}